import React from 'react';
import bannerImg from "../../../../../src/img/Untitled-1.png"
const Banner = () => {
  return (
     <div class="container px-6 py-16 mx-auto">
            <div class="items-center lg:flex">
                <div class="w-full lg:w-1/2">
                    <div class="lg:max-w-lg">
                        <h1 class="text-2xl font-semibold text-gray-800 uppercase dark:text-white lg:text-3xl">Best Place To Choose Your Clothes</h1>
                        <p class="mt-2 text-gray-600 ">Lorem ipsum dolor sit amet, consectetur adipisicing elit. Porro beatae error laborum ab amet sunt recusandae? Reiciendis natus perspiciatis optio.</p>
                        <button class="w-full px-3 py-2 mt-6 text-xs font-medium text-black uppercase transition-colors duration-200 transform bg-[#AAA3FE] rounded-md lg:w-auto hover:bg-[#8075f3] focus:outline-none focus:bg-[#7f74f3]">Shop Now</button>
                    </div>
                </div>
        
                <div class="flex items-center justify-center w-full mt-6 lg:mt-0 lg:w-1/2">
                    <img class="w-full h-full lg:max-w-2xl" src={bannerImg} alt="Catalogue-pana.svg" />
                </div>
            </div>
      </div>
  );
};

export default Banner;